import { render, staticRenderFns } from "./m-block-goods-removal.vue?vue&type=template&id=d5780d0c&scoped=true&lang=pug&"
import script from "./m-block-goods-removal.vue?vue&type=script&lang=js&"
export * from "./m-block-goods-removal.vue?vue&type=script&lang=js&"
import style0 from "./m-block-goods-removal.vue?vue&type=style&index=0&id=d5780d0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5780d0c",
  null
  
)

export default component.exports